import { createContext, PropsWithChildren, useContext } from "react";

export interface LoginConfigContextStore {
  captchaSiteKey: string;
  facebookAppId: string;
  googleClientId: string;
  appleClientId: string;
  appleRedirectUri: string;
}

export const LoginConfigContext = createContext<LoginConfigContextStore | undefined>(undefined);

export const useLoginConfig = () => useContext(LoginConfigContext);

/*
 * Provides the login configuration to the components that need it.
 * Expects server configuration in 'globalThis.serverConfig'
 * If a context was already provided it's a noop
 */
export const LoginConfigProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const context = useContext(LoginConfigContext);
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis
  if (globalThis.serverConfig === undefined && context === undefined) {
    console.warn("LoginConfigProvider, no config is found. Context is not set. Noop");
  }
  if (globalThis.serverConfig !== undefined) {
    const config: LoginConfigContextStore = {
      captchaSiteKey: globalThis.serverConfig.captchaSiteKey,
      googleClientId: globalThis.serverConfig.googleClientId,
      facebookAppId: globalThis.serverConfig.facebookAppId,
      appleClientId: globalThis.serverConfig.appleClientId,
      appleRedirectUri: globalThis.serverConfig.appleRedirectUri,
    };

    return <LoginConfigContext.Provider value={config}>{children}</LoginConfigContext.Provider>;
  } else {
    return <>{children}</>;
  }
};
